// ── AR Flow — NOVA INTERFACE: 🧠 Avaliação do atendimento (demonstração) ────
// "Usar esta mensagem" só coloca o texto na caixa; nada é enviado automaticamente.

import { useEffect, useState } from "react";

const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const TEMP = { quente: ["🔥 Quente", "#B42318"], morno: ["🌤️ Morno", "#B45309"], frio: ["❄️ Frio", "#1D4ED8"] };
const corNota = n => (n == null ? "#6B6257" : n >= 80 ? "#067647" : n >= 60 ? "#B45309" : "#B42318");

export default function AvaliacaoAtendimento({ theme, alvo, onUsar, onFechar }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const [estado, setEstado] = useState({ carregando: true });

  useEffect(() => {
    let vivo = true;
    fetch("/api/coach/avaliar", {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone: alvo?.phone, storeId: alvo?.storeId }),
    }).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || "A coach não respondeu agora."); return d; })
      .then(d => { if (vivo) setEstado({ a: d.avaliacao, restantes: d.restantesHoje }); })
      .catch(e => { if (vivo) setEstado({ erro: e.message }); });
    return () => { vivo = false; };
  }, [alvo?.phone, alvo?.storeId]);

  const a = estado.a;
  const lista = (titulo, itens, cor, marca) => itens?.length ? (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: cor }}>{titulo}</div>
      {itens.map((i, index) => <div key={`${index}-${i}`} style={{ fontSize: 14, color: th.text }}>{marca} {i}</div>)}
    </div>
  ) : null;

  return (
    <div role="dialog" aria-modal="true" aria-label="Avaliação do atendimento" onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", zIndex: 75, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: "min(500px, 100%)", maxHeight: "90vh", overflowY: "auto", background: "#fff", borderRadius: 6, border: `1px solid ${line}`, padding: "16px 18px", boxSizing: "border-box", fontFamily: "inherit" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <strong style={{ fontSize: 17, color: th.text }}>🧠 Coach · avaliação do atendimento</strong>
          <button type="button" aria-label="Fechar" onClick={onFechar} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: th.muted }}>✕</button>
        </div>
        {estado.carregando && <div style={{ fontSize: 14, color: th.muted }}>Lendo a conversa e comparando com o método da loja…</div>}
        {estado.erro && <div role="alert" style={{ fontSize: 14, color: "#991B1B" }}>{estado.erro}</div>}
        {a && (
          <>
            <div style={{ display: "flex", alignItems: "baseline", gap: 12, marginBottom: 10, flexWrap: "wrap" }}>
              <span style={{ fontFamily: MONO, fontSize: 30, fontWeight: 700, color: corNota(a.nota) }}>{a.nota == null ? "—" : a.nota}<span style={{ fontSize: 14, color: th.muted }}>/100</span></span>
              {a.temperatura && TEMP[a.temperatura] && <span style={{ fontSize: 12, fontWeight: 700, color: TEMP[a.temperatura][1], border: `1px solid ${line}`, borderRadius: 99, padding: "1px 9px" }}>{TEMP[a.temperatura][0]}</span>}
            </div>
            {a.leitura && <div style={{ fontSize: 14, color: th.text, marginBottom: 10 }}><strong>O cliente quer:</strong> {a.leitura}</div>}
            {lista("O que você fez bem", a.fezBem, "#067647", "✓")}
            {lista("O que faltou", a.faltou, "#B42318", "•")}
            {a.dica && <div style={{ background: "#F5F3FF", borderRadius: 4, padding: "8px 10px", fontSize: 14, color: th.text, marginBottom: 10 }}><strong style={{ color: "#5B21B6" }}>Dica:</strong> {a.dica}</div>}
            {a.mensagem && (
              <>
                <div style={{ fontSize: 12, fontWeight: 700, color: th.muted }}>Próxima mensagem sugerida</div>
                <div style={{ whiteSpace: "pre-wrap", fontSize: 14, color: th.text, background: th.sandDark, borderRadius: 4, padding: "8px 10px", margin: "2px 0 12px" }}>{a.mensagem}</div>
              </>
            )}
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
              <button type="button" onClick={onFechar} style={{ padding: "8px 14px", borderRadius: 4, border: `1px solid ${line}`, background: "#fff", cursor: "pointer", fontFamily: "inherit" }}>Fechar</button>
              {a.mensagem && <button type="button" onClick={() => { onUsar(a.mensagem); onFechar(); }} style={{ padding: "8px 14px", borderRadius: 4, border: "none", background: th.accent, color: "#fff", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Usar esta mensagem</button>}
            </div>
            <div style={{ fontSize: 11, color: th.muted, marginTop: 8 }}>Demonstração: a avaliação não gera pontos e não é gravada. A mensagem só vai para a caixa de texto.{Number.isFinite(estado.restantes) ? ` Restam ${estado.restantes} avaliações hoje.` : ""}</div>
          </>
        )}
      </div>
    </div>
  );
}